import React, { Component } from 'react';
import Slider from 'react-slick';
import styled from 'styled-components';

const Wrapper = styled.div`
  * {
    outline: none;
  }

  ul.slick-dots {
    text-align: center;
    li {
      cursor: pointer;
      display: inline-block;
      margin: 0 0.5em;
      background-color: black;
      border-radius: 50%;
      width: 1.5em;
      height: 1.5em;
      &.slick-active {
        background-color: ${props => props.theme.highlightColor};
      }
      
      button {
        opacity: 0;
        border: none;
        background: none;
      }
    }
  }
`;

interface Settings {

}

export interface Props {
  children?: React.ReactNode;
  settings?: Settings;
}

class SimpleCarousel extends Component<Props> {
  render() {
    const { children, settings } = this.props;

    return (
      <Wrapper>
        <Slider {...(settings || {})}>
          {children}
        </Slider>
      </Wrapper>
    )
  }
}

export default SimpleCarousel;


// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/components/carousel/SimpleCarousel.tsx